import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
import './Css/Grid.css';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Tooltip from '@material-ui/core/Tooltip';
import * as MessageList from './Saga/MessageList';
import Button from '@material-ui/core/Button';
import { smsDB } from '../../Store/FirebaseStore';
const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
let unsub
var moment = require('moment-timezone');
var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};

function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}
class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
    }
    this._onSortChange = this._onSortChange.bind(this);
  }

  render() {
    var { onSortChange, sortDir, children, ...props } = this.props;
    return (
      <Cell {...props} onClick={this._onSortChange}>
        {children} {sortDir ? (sortDir === SortTypes.DESC ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />) : ''}
      </Cell>
    );
  }

  _onSortChange(e) {
    e.preventDefault();
    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ?
          reverseSortDirection(this.props.sortDir) :
          SortTypes.DESC
      );
    }
  }
}
const columns =
  [
    { key: 'Tatemono_Name', name: '物件', width: 200, resizable: true },
    { key: 'Room_Name', name: '部屋', width: 200, resizable: true },
    { key: 'name', name: '氏名', width: 200, resizable: true },
    { key: 'return_code', name: '送信結果', width: 200, resizable: true },
  ]

const Base = ({ column, props, rowIndex }) =>
  <Tooltip placement="bottom-start" title={props[rowIndex][column.key]}>
    <Cell style={{ whiteSpace: "nowrap" }} > {props[rowIndex][column.key]} </Cell>
  </Tooltip>

const Error = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props[rowIndex][column.key] !== 200 ? <div style={{ color: "red" }}>送信エラー</div> : ""}
  </Cell>


class CustomerList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: columns,
      reflash: false,
      colSortDirs: {},

    };




    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);
    this._onSortChange = this._onSortChange.bind(this);

  }
  _onColumnResizeEndCallback(newColumnWidth, columnKey) {

    let columnsset = this.state.columns.map(function (value) {
      if (value.key === columnKey) {
        value.width = newColumnWidth
      }
      return value
    })

    this.setState({ columns: columnsset })

  }





  _onSortChange(columnKey, sortDir) {

    let seisan_follow_search_list = this.props.issei_details;
    seisan_follow_search_list.sort((indexA, indexB) => {
      var valueA = indexA[columnKey];
      var valueB = indexB[columnKey];
      var sortVal = 0;
      if (valueA > valueB) {
        sortVal = 1;
      }
      if (valueA < valueB) {
        sortVal = -1;
      }

      if (!valueA && !valueB) {
        sortVal = 0
      }
      if (!valueA) {
        sortVal = -1
      }
      if (!valueB) {
        sortVal = 1
      }


      if (sortVal !== 0 && sortDir === SortTypes.DESC) {
        sortVal = sortVal * -1;
      }

      return sortVal;
    });
    this.setState({
      // sortedDataList: new DataListWrapper(sortIndexes, this._dataList),
      colSortDirs: {
        [columnKey]: sortDir,
      },
    });
  }

  render() {
    return (
      <div id="Keiyaku">

        <Table
          rowHeight={30}
          rowsCount={this.props.issei_details.length}
          // rowsCount={10}
          onColumnResizeEndCallback={this._onColumnResizeEndCallback}
          width={800}
          height={window.innerHeight - 300}
          headerHeight={30}>
          {columns.map(function (value, i) {
            return <Column
              columnKey={value.key}
              header={<SortHeaderCell
                onSortChange={this._onSortChange}
                sortDir={this.state.colSortDirs[value.key]}
                style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

              // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
              cell={({ rowIndex, ...props }) => (
                value.key === "return_code" ? <Error column={value} props={this.props.issei_details} rowIndex={rowIndex}></Error>
                  : <Base column={value} props={this.props.issei_details} rowIndex={rowIndex} ></Base>
              )}
              width={this.state.columns.filter(a => a.key === value.key)[0].width}
              isResizable={true}
              fixed={value.frozen}

            />
          }, this)}
        </Table >

      </div >
    );
  }
};


//export  default CustomerList;
const mapStateToProps = (state) => {
  return {
    issei_details: state.MessageList.issei_details,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    newmessage_customers(state) {
      dispatch(MessageList.newmessage_customers(state))
    },
    issei_detail(state) {
      dispatch(MessageList.issei_detail(state))
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);